import axiosInstance from "../axios";

class SubmissionDataService {
  get(id: any) {
    return axiosInstance.get(`/studentui/submissions/${id}`);
  }
}

export default new SubmissionDataService();
